import React, { Component } from "react";
import _ from "lodash";

import { helpMessage } from './onboarding';

class OnboardingRejected extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };

  }

  render() {
    const {
      currentContractor,
    } = this.props;

    if (currentContractor.status != 'scorer_rejected') {
      window.location.href = '/onboarding';
      return null;
    }

    return (
      <div className="onboarding-container">
        <div className="onboarding-body">
          <div className="onboarding-body-inner">
            <div className="onboarding-rejection-container">
              <div className="onboarding-biglabel onboarding-rejection-body">
                <div>Thank you for your application and time.</div>

                <div>Unfortunately, your skillset is not a match for a Quality Analyst role at this time.</div>

                <div>
                  However, if you are interested in a Transcriptionist post, kindly apply at
                  {window.PRELOAD_STATE.config_vars.QA_WORLD_URL_INFO.domain} with a different email.
                </div>
              </div>
            </div>
          </div>
          <div className="onboarding-footer onboarding-biglabel">
            {helpMessage(!currentContractor.transcribe_only)}
          </div>
        </div>
      </div>
    );
  }
}

export default OnboardingRejected;
